import { isNewsItemResponseDTO } from "../DTO/ServerResponseType/News/NewsItem";
import {
  isNewsItemIdResponseDTO,
  NewsItemIdResponseApi,
} from "../DTO/ServerResponseType/News/NewsItemId";
import {
  isNewsItemImageIdResponseDTO,
  NewsItemImageIdResponseApi,
} from "../DTO/ServerResponseType/News/NewsItemImageId";
import { NewsItemResponseApi } from "../DTO/ServerResponseType/News/NewsItem";
import { NewsItemStore } from "../Stores/NewsItemStore";
import { ServerClient, serverOrigin } from "./Configs";
import {
  getTypeGuardedArrayVariableAsync,
  getTypeGuardedVariableAsync,
} from "./typeGuard";

class NewsServerClient {
  private path = "/news";

  sendToUpdateNewsAsync = async (newsData: NewsItemStore): Promise<null> => {
    await this.sendUpdatedNewsAsync(newsData)
      .then(() => {
        alert("Новость успешно изменена.");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
      });

    return null;
  };

  sendUpdatedNewsAsync = async (newsData: NewsItemStore): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/update/all";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        newsId: newsData.newsItem.newsId,
        newsNewData: newsData.newsItem,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToCreateNewsAsync = async (
    newsData: NewsItemStore
  ): Promise<string | null> => {
    let newsId: string | null = await getTypeGuardedVariableAsync(
      this.sendNewNewsAsync(newsData),
      isNewsItemIdResponseDTO
    )
      .then((newsItemIdDTO: NewsItemIdResponseApi) => {
        alert("Новость успешно создана.");
        return newsItemIdDTO.newsId;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        return null;
      });

    return newsId;
  };

  sendNewNewsAsync = async (newsData: NewsItemStore): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/create";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(newsData.newsItem),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToCreateNewsItemImageAsync = async (
    newsId: string,
    imageData: File
  ): Promise<string> => {
    return await getTypeGuardedVariableAsync(
      this.sendNewNewsItemImageAsync(newsId, imageData),
      isNewsItemImageIdResponseDTO
    ).then((newsItemImageIdDTO: NewsItemImageIdResponseApi) => {
      alert("Изображение для новости успешно создано.");
      return newsItemImageIdDTO.newsImageId;
    });
  };

  sendNewNewsItemImageAsync = async (
    newsId: string,
    imageData: File
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/image/create";

    let formData = new FormData();
    formData.append("newsId", newsId);
    formData.append("imageData", imageData);

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: formData,
      credentials: "include",
    });

    return response;
  };

  sendToDeleteNewsImageAsync = async (
    newsImageId: string
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/image/delete";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ newsImageId: newsImageId }),
      headers: {
        "Content-Type": "application/json",
      },

      credentials: "include",
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  };

  sendToGetAllNewsAsync = async (): Promise<NewsItemResponseApi[] | never> => {
    let url: string = serverOrigin + this.path + "/show/all";

    let responseBody: NewsItemResponseApi[] =
      await getTypeGuardedArrayVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isNewsItemResponseDTO
      );

    return responseBody;
  };

  sendToGetAnyNewsAsync = async (
    countNews: number
  ): Promise<NewsItemResponseApi[] | never> => {
    let url: string =
      serverOrigin + this.path + "/show/all?countNews=" + countNews.toString();

    let responseBody: NewsItemResponseApi[] =
      await getTypeGuardedArrayVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isNewsItemResponseDTO
      );

    return responseBody;
  };

  sendToGetNewsItemByNewsItemIdAsync = async (
    newsId: string
  ): Promise<NewsItemResponseApi | never> => {
    let url: string = serverOrigin + this.path + "/show/one?newsId=" + newsId;

    let responseBody: NewsItemResponseApi = await getTypeGuardedVariableAsync(
      ServerClient.sendRequestAsync({
        url: url,
        method: "GET",
        credentials: "include",
      }),
      isNewsItemResponseDTO
    );

    return responseBody;
  };

  sendToDeleteNewsAsync = async (newsId: string): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/delete";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ newsId: newsId }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  };
}

let newsServerClient = new NewsServerClient();

export default newsServerClient;
